
const SvgComponent = () => {
    const w = 24
    const h = 24
    return (
        <svg xmlns="http://www.w3.org/2000/svg" data-name="check box" width={w} height={h} viewBox="0 0 24 24">
            <path data-name="check box" fill="#264f36" d="M0 0h24v24H0z" />
            <path d="M6.9 12 1 6.1l1.4-1.4 4.5 4.4L15 1l1.4 1.4z" transform="translate(3.3 5.5)" fill="#fff" />
        </svg>
    )
}

export default SvgComponent
